import {
  Typography,
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { Theme, useTheme } from '@mui/material/styles'
import { createStyles, makeStyles } from '@mui/styles';
import { Edit, AddCircle, RemoveCircle } from "@mui/icons-material";
import { materialText } from "../../utils/GetAML";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {},
    centerTitle: {
      textAlign: "center",
      padding: theme.spacing(1),
    },
    edited: {},
    removed: {
      color: theme.palette.statusRed.main,
    },
    added: {
      color: theme.palette.statusGreen.main,
    },
    cellChanged: {
      fontWeight: "bolder",
      backgroundColor: theme.palette.highlightRow.main,
    },
    cell: {},
    cards: {},
  })
);

export interface mat_sum_line {
  materialNum: string;
  change: {
    action: string;
    capacity: boolean;
    columnCount: boolean;
    stockoutDays: boolean;
    vendPrice: boolean;
  };
  R: {
    capacity: number;
    columnCount: number;
    stockoutDays: number;
    vendPrice: number;
  };
  C: {
    capacity: number;
    columnCount: number;
    stockoutDays: number;
    vendPrice: number;
  };
}
export default function CardChangeSummary(
  props: { mat_sum: mat_sum_line[]; material_text: materialText[], hideTitle?: boolean },

) {
  const classes = useStyles();
  const mat_sum = props.mat_sum;
  const mat_txt = props.material_text;

  const getMaterialText = (materialNum: string) => {
    let materialNumShort: string = "";
    let description: string = "";
    if (mat_txt && mat_txt.length > 0) {
      let mt = mat_txt.find((mt) => mt.materialNum === materialNum);
      if (mt) {
        materialNumShort = mt.materialNumShort || "";
        description = mt.description || "";
      }
    }
    return { materialNumShort, description };
  };

  return (
    <Card className={classes.cards}>
      <CardContent>
        {!props.hideTitle && (
          <Typography variant="h4" className={classes.centerTitle}>
            Change Summary
          </Typography>
        )}

        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>SKU</TableCell>
                <TableCell>Material</TableCell>
                <TableCell>Action</TableCell>
                <TableCell>Columns (c)</TableCell>
                <TableCell>Capacity (c)</TableCell>
                <TableCell>Price (c)</TableCell>
                <TableCell>Stockout Days (c)</TableCell>
                <TableCell>Columns (r)</TableCell>
                <TableCell>Capacity (r)</TableCell>
                <TableCell>Price (r)</TableCell>
                <TableCell>Stockout Days (r)</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {mat_sum.map((mat_line: mat_sum_line) => {
                let cur_mat_txt = getMaterialText(mat_line.materialNum);

                let icon = <></>;
                if (mat_line.change.action === "ADD")
                  icon = (
                    <AddCircle fontSize="small" className={classes.added} />
                  );
                if (mat_line.change.action === "EDIT")
                  icon = <Edit fontSize="small" className={classes.edited} />;
                if (mat_line.change.action === "REMOVE")
                  icon = (
                    <RemoveCircle
                      fontSize="small"
                      className={classes.removed}
                    />
                  );

                return (
                  <TableRow>
                    <TableCell>{cur_mat_txt?.materialNumShort}</TableCell>
                    <TableCell>{cur_mat_txt?.description}</TableCell>
                    <TableCell>{icon}</TableCell>
                    {mat_line.change.action !== "ADD" ? (
                      <>
                        <TableCell>{mat_line.C.columnCount}</TableCell>
                        <TableCell>{mat_line.C.capacity}</TableCell>
                        <TableCell>{mat_line.C.vendPrice}</TableCell>
                        <TableCell>{mat_line.C.stockoutDays}</TableCell>
                      </>
                    ) : (
                      <>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                      </>
                    )}
                    {mat_line.change.action !== "REMOVE" ? (
                      <>
                        <TableCell
                          className={
                            mat_line.change.columnCount
                              ? classes.cellChanged
                              : classes.cell
                          }
                        >
                          {mat_line.R.columnCount}
                        </TableCell>
                        <TableCell
                          className={
                            mat_line.change.capacity
                              ? classes.cellChanged
                              : classes.cell
                          }
                        >
                          {mat_line.R.capacity}
                        </TableCell>
                        <TableCell
                          className={
                            mat_line.change.vendPrice
                              ? classes.cellChanged
                              : classes.cell
                          }
                        >
                          {mat_line.R.vendPrice}
                        </TableCell>
                        <TableCell
                          className={
                            mat_line.change.stockoutDays
                              ? classes.cellChanged
                              : classes.cell
                          }
                        >
                          {mat_line.R.stockoutDays}
                        </TableCell>
                      </>
                    ) : (
                      <>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                      </>
                    )}
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>
    </Card>
  );
}
